import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { settings, clearActivateParam } from "../../../settings";
import { http } from "../../Common/api";
import { newsEventApi } from "../api";
import {
  setNewsEventSubscription,
  setNewsEventListing,
  setNewsEventActive,
} from "../actions";

// Loads the financial calendar subscription named by the `id` query parameter,
// plus the company styling. Mirrors UseGetSubscription on the index page.
export const UseGetNewsEventSubscription = () => {
  const dispatch = useDispatch();
  const [styles, setStyle] = useState({});
  const [isAppReady, setAppReady] = useState(false);

  useEffect(() => {
    const toErrorPage = () => {
      settings.history.push({
        pathname: "/error-page",
        search: `?lang=${settings.lang}`,
      });
    };

    const getSubscription = async () => {
      const subscription = await newsEventApi
        .get(settings.listing)
        .then((response) => response.data)
        .catch(() => {
          toErrorPage();
        });

      if (!subscription) {
        setAppReady(true);
        return;
      }

      document.title = `Financial Calendar Preferences - ${subscription.companyName}`;
      dispatch(setNewsEventSubscription(subscription));

      // Activation is a one-off. The subscription says whether it has already
      // been confirmed, and the backend mails the subscriber on every activate
      // call, so re-running it on a refresh would spam them.
      if (settings.activate === "true") {
        if (subscription.id && !subscription.active) {
          await newsEventApi
            .activate(subscription.id)
            .then(() => dispatch(setNewsEventActive(true)))
            .catch(() => {
              console.log("Error: activate");
            });
        }
        clearActivateParam();
      }

      // The subscription only knows its listing, but the styles service is
      // keyed by company, so resolve one to the other first.
      if (subscription.listingId) {
        const listing = await newsEventApi
          .listing(subscription.listingId)
          .then((response) => response.data)
          .catch(() => {
            console.log("Error: listing");
          });

        if (listing) {
          dispatch(setNewsEventListing(listing));
        }

        if (listing && listing.companyId) {
          try {
            const companyStyles = await http
              .getStyles(listing.companyId)
              .then((response) => response.data);
            setStyle(companyStyles.configuration.global);
          } catch (e) {
            console.log("Error: dataStyles");
          }
        }
      }

      setAppReady(true);
    };

    if (settings.listing) {
      getSubscription();
    } else {
      toErrorPage();
    }
  }, [dispatch]);

  return [styles, isAppReady];
};
